import { useState, useEffect } from 'react';
import { AppButton } from '../ui/buttons';
import './InactivityWarningModal.scss';

interface InactivityWarningModalProps {
  isOpen: boolean;
  onExtend: () => void;
  onLogout: () => void;
  secondsRemaining?: number;
}

export function InactivityWarningModal({
  isOpen,
  onExtend,
  onLogout,
  secondsRemaining = 300 // Default 5 minutes
}: InactivityWarningModalProps) {
  const [timeLeft, setTimeLeft] = useState(secondsRemaining);

  useEffect(() => {
    if (isOpen) {
      setTimeLeft(secondsRemaining);
      
      const interval = setInterval(() => {
        setTimeLeft(prev => {
          if (prev <= 1) {
            clearInterval(interval);
            onLogout();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [isOpen, secondsRemaining, onLogout]);

  if (!isOpen) return null;

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  return (
    <div className="inactivity-modal-overlay">
      <div className="inactivity-modal">
        <div className="modal-header">
          <h3>Session Expiring Soon</h3>
        </div>
        
        <div className="modal-body">
          <div className="warning-icon">⚠️</div>
          <p>Your session will expire due to inactivity in:</p>
          <div className="countdown">
            {minutes}:{seconds.toString().padStart(2, '0')}
          </div>
          <p className="warning-text">
            Would you like to continue your session?
          </p>
        </div>
        
        <div className="modal-actions">
          <AppButton
            variant="secondary"
            onClick={onLogout}
          >Logout Now</AppButton>
          <AppButton
            variant="primary"
            onClick={onExtend}
          >Continue Session</AppButton>
        </div>
      </div>
    </div>
  );
}